export const LEAD_CHECKLISTS_FETCH_REQUESTED = 'LEAD_CHECKLISTS_FETCH_REQUESTED'
export const LEAD_CHECKLISTS_FETCH_SUCCESS = 'LEAD_CHECKLISTS_FETCH_SUCCESS'
export const CREATE_LEAD_CHECKLIST_REQUESTED = 'CREATE_LEAD_CHECKLIST_REQUESTED'
export const CREATE_LEAD_CHECKLIST_SUCCESS = 'CREATE_LEAD_CHECKLIST_SUCCESS'
export const LEAD_CHECKLIST_MARK_ITEM_COMPLETED_REQUESTED =
  'LEAD_CHECKLIST_MARK_ITEM_COMPLETED_REQUESTED'
export const LEAD_CHECKLIST_MARK_ITEM_COMPLETED_SUCCESS =
  'LEAD_CHECKLIST_MARK_ITEM_COMPLETED_SUCCESS'
export const LEAD_CHECKLIST_TOGGLE_ITEM_COMPLETED_SUCCESS =
  'LEAD_CHECKLIST_TOGGLE_ITEM_COMPLETED_SUCCESS'
export const LEAD_CHECKLIST_TOGGLE_ITEM_COMPLETED_REQUESTED =
  'LEAD_CHECKLIST_TOGGLE_ITEM_COMPLETED_REQUESTED'
export const DELETE_LEAD_CHECKLIST_ITEM_REQUESTED = 'DELETE_LEAD_CHECKLIST_ITEM_REQUESTED'
export const DELETE_LEAD_CHECKLIST_ITEM_SUCCESS = 'DELETE_LEAD_CHECKLIST_ITEM_SUCCESS'
export const DELETE_LEAD_CHECKLIST_REQUESTED = 'DELETE_LEAD_CHECKLIST_REQUESTED'
export const DELETE_LEAD_CHECKLIST_SUCCESS = 'DELETE_LEAD_CHECKLIST_SUCCESS'
export const ADD_LEAD_CHECKLIST_ITEM_REQUESTED = 'ADD_LEAD_CHECKLIST_ITEM_REQUESTED'
export const ADD_LEAD_CHECKLIST_ITEM_SUCCESS = 'ADD_LEAD_CHECKLIST_ITEM_SUCCESS'
export const UPDATE_LEAD_CHECKLIST_REQUESTED = 'UPDATE_LEAD_CHECKLIST_REQUESTED'
export const UPDATE_LEAD_CHECKLIST_SUCCESS = 'UPDATE_LEAD_CHECKLIST_SUCCESS'
export const UPDATE_LEAD_CHECKLIST_ITEM_REQUESTED = 'UPDATE_LEAD_CHECKLIST_ITEM_REQUESTED'
export const UPDATE_LEAD_CHECKLIST_ITEM_SUCCESS = 'UPDATE_LEAD_CHECKLIST_ITEM_SUCCESS'
